import PrematchDataFetcher from './PrematchDataFetcher';
import Outlet from '../router/Outlet';
import { isPrematchRoute, livePrefix, prematchPrefix } from '../Container';
import FavoriteTournamentsProvider from '../common/favorite-tournaments/FavoriteTournamentsProvider';
import FavoriteEventsProvider from '../common/favorite-events/FavoriteEventsProvider';
import PageDataProvider from '../common/PageDataProvider';

function getPrefix() {
    let prefix = prematchPrefix;
    {
        const re = new RegExp(`^(?<prefix>${prematchPrefix}\\/d\\-\\d).*$`)
        if (re.test(window.location.pathname)) {
            const res = re.exec(window.location.pathname);
            prefix = `${res.groups.prefix}`;
        }
    }
    {
        const re = new RegExp(`^(?<prefix>${prematchPrefix}\\/h\\-\\d).*$`)
        if (re.test(window.location.pathname)) {
            const res = re.exec(window.location.pathname);
            prefix = `${res.groups.prefix}`;
        }
    }
    return prefix;
}

export function getSportUrl(s) {
    if (isPrematchRoute()) {
        const prefix = getPrefix();
        if (s.urlPath != null) {
            return `${prefix}/${s.urlPath}${s.urlPathSuffix}`;
        }
        return `${prefix}/s_${s.id}`;
    }
    return `${livePrefix}/s_${s.id}`;
}

export function getCategoryUrl(c) {
    if (isPrematchRoute()) {
        const prefix = getPrefix();
        if (c.urlPath) {
            return `${prefix}/${c.urlPath}${c.urlPathSuffix}`;
        }
        return `${prefix}/c_${c.sportRef}_${c.id}`;
    }
    return `${livePrefix}/c_${c.sportRef}_${c.id}`;
}

export function getTournamentUrl(t) {
    if (isPrematchRoute()) {
        const prefix = getPrefix();
        if (t.urlPath) {
            return `${prefix}/${t.urlPath}${t.urlPathSuffix}`;
        }
        return `${prefix}/t_${t.sportRef}_${t.categoryRef}_${t.id}`;
    }
    return `${livePrefix}/t_${t.sportRef}_${t.categoryRef}_${t.id}`;
}

export function getEventUrl(e) {
    if (!e.isLive) {
        const prefix = getPrefix();
        if (e.urlPath != null) {
            return `${prefix}/${e.urlPath}`;
        }
        return `${prefix}/e_${e.sportRef}_${e.categoryRef}_${e.tournamentRef}_${e.pal}_${e.avv}`;
    }
    return `${livePrefix}/e_${e.sportRef}_${e.categoryRef}_${e.tournamentRef}_${e.pal}_${e.avv}`;
}

export default function Prematch() {
    return (
        <PrematchDataFetcher>
            <PageDataProvider>
                <FavoriteTournamentsProvider>
                    <FavoriteEventsProvider>
                        <Outlet />
                    </FavoriteEventsProvider>
                </FavoriteTournamentsProvider>
            </PageDataProvider>
        </PrematchDataFetcher>
    );
}
